import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "@/auth/AuthProvider";
import { ApiTokenBridge } from "@/auth/ApiTokenBridge";
import { App } from "@/App";
import "@/index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ApiTokenBridge>
          <App />
        </ApiTokenBridge>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
